import { combineReducers } from 'redux'

import { reducer as accounts } from './accountsSlice'
import { reducer as application } from './applicationSlice'
import step from './step'

export default combineReducers({ application, accounts, step })
